const MODAL_NAMES = {
  DOWNLOAD_EXTENSION: 'download_extension',
  REINSTALL_EXTENSION: 'reinstall_extension',
  CHAT_WITH_US: 'chat_with_us',
  SEARCH: 'search',
  STORE_INFO: 'store_info',
  MANAGE_STORES: 'manage_stores',
  DELETE_ACCOUNT: 'delete_account',
  PRODUCT: 'product',
  X_PLATFORM: 'x-platform',
  GLOBAL_SEARCH_TOOLTIP: 'global_search_tooltip',
  LOYALTY_FORM: 'loyalty_form',
  KARMA_EARN_PLAY_ALL_DEVICES: 'earn_play_all_devices',
  KARMA_EARN_PLAY_MOBILE_DEVICES: 'earn_play_mobile_devices',
  KARMA_EARN_REDIRECT_ERROR: 'earn_redirect_error',
  KARMA_EARN_REDIRECT_LOADING: 'earn_redirect_loading',
  KARMA_EARN_GAME_GENRES: 'earn_game_genres',
  GIFT_CARD_CANCEL: 'gift_card_cancel',
  GIFT_CARD_EMAIL_SEND: 'gift_card_email_send',
  GIFT_CARD_NO_EMAIL: 'gift_card_no_email',
  GIFT_CARD_CATEGORIES: 'gift_card_categories',
  WITHDRAW_PAYPAL_BLOCKED_BY_GIFT_CARD: 'withdraw_paypal_blocked_by_gift_card',
};

export default MODAL_NAMES;
